module.exports = __webpack_public_path__ + "static/media/login-icon.f62905ef.png";